var map = {
	"./homepage/blockallow.gif": "6289",
	"./homepage/buildings.svg": "6116",
	"./homepage/import.svg": "6870",
	"./homepage/interaction.svg": "38d3",
	"./homepage/profile.svg": "64ae",
	"./homepage/server.svg": "ee33",
	"./homepage/studioManager.gif": "3b93",
	"./homepage/talking.svg": "679d",
	"./homepage/tweetricon.svg": "4644",
	"./homepage/upload.svg": "b08c",
	"./homepage/usabilitytest.svg": "2f93",
	"./homepage/vc.png": "ceed",
	"./homepage/whiteboard.svg": "7e8a",
	"./logo.svg": "9b19",
	"./logoload.svg": "9192",
	"./logoload2.svg": "3fd0",
	"./newbook.svg": "6b36",
	"./powerpoint.svg": "8b60",
	"./widget-thumbnails/cat.svg": "db7d",
	"./widget-thumbnails/chat.svg": "7849",
	"./widget-thumbnails/completed-task.svg": "d9fc",
	"./widget-thumbnails/logo.png": "eed9",
	"./widget-thumbnails/markdown.svg": "b1cc",
	"./widget-thumbnails/pencil.svg": "1b92",
	"./widget-thumbnails/upload.svg": "63fb",
	"./widget-thumbnails/video-call.svg": "80b3",
	"./widget-thumbnails/video-player.svg": "30a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";